// Copyright (c) Docugami, Inc. All rights reserved.

import { Icon } from "@fluentui/react";
import { appContentColor, primaryTheme } from "components/shell/presentation/AppStyles";
import { ConfirmationDialog } from "components/shell/utils/ConfirmationDialog";
import { useDgIcons, dgIconNames } from "hooks/dgIcons";
import styled from "styled-components";
import { ModalContentContainer } from "./ReportTableComponents";
import { AutomationId } from "utils/Automation";
import { useAppSelector } from "hooks/redux";
import { selectReportLabels } from "store/reports/selectors";

const IconContainer = styled.span`
    height: 20px;
    width: 20px;
    padding: 0 3px;
`

interface OneClickFirstTimeModalProps {
    hidden: boolean;
    onDismiss: () => void;
    numberOfEntries: number;
}

export const OneClickCoachmarkModal = (props: OneClickFirstTimeModalProps): JSX.Element => {
    const { icon } = useDgIcons();

    const reportLabels = useAppSelector(selectReportLabels);

    return (
        <ConfirmationDialog
            data-automation-id={AutomationId.OneClickCoachmarkModal}
            hidden={props.hidden}
            confirmButtonText="GOT IT"
            confirmedCallback={props.onDismiss}
            dismissedCallback={props.onDismiss}
            styles={{
                main: {
                    selectors: {
                        '@media (min-width: 480px)': {
                            width: 600,
                            maxWidth: '1000px'
                        }
                    }
                }
            }}>
            <ModalContentContainer>
                <p>
                    We’ve suggested {props.numberOfEntries} items for your {reportLabels.itemsName.toLocaleLowerCase()}. Scroll right to see all your items.
                </p>
                <p>
                    Click the Doc View <IconContainer>{icon(dgIconNames.DgPageNoWriting, '', 20, 20, appContentColor, primaryTheme.palette.black)}</IconContainer> icon or a document name to add or modify items.
                </p>
                <p>
                    You can remove suggestions using the option <IconContainer><Icon iconName='MoreVertical' styles={{ root: { width: 20, height: 20, color: appContentColor } }} /></IconContainer> menus.
                </p>
            </ModalContentContainer>
        </ConfirmationDialog>
    )
}
